import React from "react";
import Button from '../Button/Button'
import style from './CardListButton.module.css'


const CardListButton = ({
  options = [],
  picture = '',
  Icon,
  text,
  textButton,
  key = '',
  onClick = ()=>{},
  styleImg

}) => {

  return (
    <div key={key} className={style.container_card_list} onClick={onClick}>
        <div className={style.content_img_card_list} >
        {(picture!='' )&& <img alt="img" className={style.img_card_list} src={picture}></img>}
          {(Icon!=null) && <Icon className={styleImg} />}
        </div>

        <div className={style.container_text}>
            <div className={style.text_card_list}>
            {text}
            </div>

            <Button 
            theme={style.card_list_button}
            text = {textButton}
            type = "button"
            onClick = { e=> { e.preventDefault(); e.stopPropagation(); onClick(e)} } />
        </div>

    </div>
  );
};

export default CardListButton;
